module.exports = "/ui/f3197c899e01d22a6578f05e3585f5b4.jpg";